
  if(jQuery(window).width()>=769){
      var mySwiper = new Swiper('.dare_to',{
  pagination : '.swiper-pagination',
  paginationType : 'bullets',
  paginationClickable :true,
  paginationHide :false,
  spaceBetween: 10,
    slidesPerView : 3,
 prevButton:'.swiper-button-prev',
nextButton:'.swiper-button-next',
  })
  var mySwiper = new Swiper('.dares',{
  pagination : '.swiper-pagination',
  paginationType : 'bullets',
  paginationClickable :true,
  paginationHide :false,
  spaceBetween: 10,
    slidesPerView : 1,
 prevButton:'.swiper-button-prev',
nextButton:'.swiper-button-next',
  })
  }
 if(jQuery(window).width()<=768){
      var mySwiper = new Swiper('.dare_to',{
  pagination : '.swiper-pagination',
  paginationType : 'bullets',
  paginationClickable :true,
  paginationHide :false,
  spaceBetween: 10,
 slidesPerView : 1.5,
prevButton:'.swiper-button-prev',
nextButton:'.swiper-button-next',
  })
  var mySwiper = new Swiper('.dares',{
  pagination : '.swiper-pagination',
  paginationType : 'bullets',
  paginationClickable :true,
  paginationHide :false,
  spaceBetween: 10,
    slidesPerView : 1,
 prevButton:'.swiper-button-prev',
nextButton:'.swiper-button-next',
  })
  }